module.exports = __webpack_public_path__ + "static/media/d2.b70c3085.jpg";